export class MessageTemplate {
  id: number;
  name: string;
  subject: string;
  subtitle: string;
  body: string;
  type: number;
  createdBy: string;
  creationDate: Date;
}
